import { SPACE } from '@nxt-insurance/ui-kit/constants'

export const MAX_CONTENT_WIDTH = 1440
export const ONE_COLUMN_WIDTH = MAX_CONTENT_WIDTH - SPACE.xxlarge * 2
const CONTENT_WRAPPER_WIDTH = 990

export const BLOG_CONTENT_WIDTH = CONTENT_WRAPPER_WIDTH - SPACE.gutter * 2
